<template>
    <div class="top-menu-item">
        <img v-if="icon" :src="icon" width="32" height="32" /> 
        <span v-else class="no-image"></span>
        <span class="margin"></span>
        <slot>
            <a :href="url">
                {{name}}
            </a>
        </slot>
        <div class="point"></div>
    </div>
</template>

<script>
export default {
    props: ["name", "icon", "url"],
    components: {
    },
    mounted() {
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-item {
        position: relative;
        &:hover {
            a {
                color: #6179E0;
            }
            .point {
                display: block;
            }
        }

        .margin {
            display: inline-block;
            width: 6px;
        }


        a {
            text-decoration: none;
            color: #808080;
        }
        .no-image {
            display: inline-block;
            width: 24px;
            margin-right: 4px;
        }
        .point {
            position: absolute;
            left: 10px;
            top: 9px;
            background: #6179E0;
            height: 6px;
            width: 6px;
            border-radius: 50px;
            display: none;
        }
    }

</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
